module.exports = __webpack_public_path__ + "img/br.ae39afc.svg";